import { I18N_PREFIX } from './../constants';

export const SPORTS_CLASS_BLOCK_NAME = 'bb-inplay-sport';
export const SPORT_VIEW_ALL_CLASS_BLOCK_NAME = 'bb-inplay-sport-view-all-link';
export const SPORT_COLLAPSED_CLASS_NAME = `${SPORTS_CLASS_BLOCK_NAME}--collapsed`;
export const SPORT_HEADER_CLASS_NAME = `${SPORTS_CLASS_BLOCK_NAME}__header`;
export const SPORT_TITLE_CLASS_NAME = `${SPORTS_CLASS_BLOCK_NAME}__title`;
export const SPORT_TOURNAMENTS_CLASS_NAME = `${SPORTS_CLASS_BLOCK_NAME}__tournaments`;
export const SPORT_DROPDOWN_ICON_CLASS_NAME = `${SPORTS_CLASS_BLOCK_NAME}__dropdown-icon`;
export const SPORT_HIDDEN_CLASS_NAME = `${SPORTS_CLASS_BLOCK_NAME}--hidden`;
export const SPORT_FOOTER_CLASS_NAME = `${SPORTS_CLASS_BLOCK_NAME}__footer`;
export const SPORT_TOP_BANNER_CLASS_NAME = `${SPORTS_CLASS_BLOCK_NAME}__top-banner`;
export const SPORT_ID_HTML_ATTR_NAME = 'data-sport-id';

export const TOURNAMENT_CLASS_BLOCK_NAME = 'bb-inplay-tournament';
export const TOURNAMENT_HEADER_CLASS_NAME = `${TOURNAMENT_CLASS_BLOCK_NAME}__header`;
export const TOURNAMENT_TITLE_CLASS_NAME = `${TOURNAMENT_CLASS_BLOCK_NAME}__title`;
export const TOURNAMENT_EVENTS_CLASS_NAME = `${TOURNAMENT_CLASS_BLOCK_NAME}__events`;
export const TOURNAMENT_DROPDOWN_ICON_CLASS_NAME = `${TOURNAMENT_CLASS_BLOCK_NAME}__dropdown-icon`;
export const TOURNAMENT_COLLAPSED_CLASS_NAME = `${TOURNAMENT_CLASS_BLOCK_NAME}--collapsed`;
export const TOURNAMENT_HIDDEN_CLASS_NAME = `${TOURNAMENT_CLASS_BLOCK_NAME}--hidden`;
export const TOURNAMENT_ID_HTML_ATTR_NAME = 'data-tournament-id';

export const COLUMN_LABELS_CLASS_NAME = `${SPORTS_CLASS_BLOCK_NAME}__column-labels`;
export const COLUMN_LABEL_CLASS_NAME = `${SPORTS_CLASS_BLOCK_NAME}__column-label`;
export const COLUMN_LABEL_CLASS_NAME_THREE_MARKET = `${COLUMN_LABELS_CLASS_NAME}__three-market-view`;
export const COLUMN_LABELS_HIDDEN_CLASS_NAME = `${COLUMN_LABELS_CLASS_NAME}--hidden`;

export const TOP_MENU_CLASS_BLOCK_NAME = 'bb-menu-tabs';
export const TOP_MENU_BLOCK_MODIFIER = 'inplay';
export const TOP_MENU_ALL_SPORTS_TEXT = `${I18N_PREFIX}.all_sports`;
export const TOP_MENU_SCHEDULE_TEXT = `${I18N_PREFIX}.schedule`;
export const TOP_MENU_LINK_ALL_SPORTS_MODIFIER = 'all-sports';
export const TOP_MENU_LINK_ALL_SPORTS_GTM = 'all-sports';
export const TOP_MENU_LINK_VIRTUAL_SPORTS_GTM = 'virtual-sports';
export const TOP_MENU_LINK_SCHEDULE_GTM = 'schedule';

export const SCHEDULE_MENU_CLASS_BLOCK_NAME = 'bb-inplay-schedule-menu';
export const SCHEDULE_MENU_HIDDEN_CLASS_NAME = `${SCHEDULE_MENU_CLASS_BLOCK_NAME}--hidden`;
export const SCHEDULE_MENU_LINK_CLASS_BLOCK_NAME = `${SCHEDULE_MENU_CLASS_BLOCK_NAME}__link`;
export const SCHEDULE_MENU_LINK_SELECTED_CLASS_NAME = `${SCHEDULE_MENU_LINK_CLASS_BLOCK_NAME}--selected`;
export const SCHEDULE_MENU_WEEK_DAY_CLASS_BLOCK_NAME = `${SCHEDULE_MENU_LINK_CLASS_BLOCK_NAME}__week-day`;
export const SCHEDULE_MENU_DAY_CLASS_BLOCK_NAME = `${SCHEDULE_MENU_LINK_CLASS_BLOCK_NAME}__day`;
export const SCHEDULE_MENU_TODAY_CLASS_BLOCK_NAME = `${SCHEDULE_MENU_LINK_CLASS_BLOCK_NAME}__today`;
export const SCHEDULE_MENU_TODAY_HIDDEN_CLASS_NAME = `${SCHEDULE_MENU_TODAY_CLASS_BLOCK_NAME}--hidden`;
export const SCHEDULE_MENU_LINK_TODAY_TEXT = `${I18N_PREFIX}.today`;

export const VIEW_ALL_MATCHES_TEXT = `${I18N_PREFIX}.see_[count]_match`;
export const VIEW_ALL_LINK_SLUG_HTML_DATA_ATTR_NAME = 'data-slug';

export const SPORT_EVENT_COUNTER_CHANGE_EVENT = 'inplay:sport::event:counter:increased';

export const GTM_ATTRIBUTE_NAME = 'data-spectate-product';
export const GTM_ATTRIBUTE_INPLAY = 'inplay';
export const GTM_ATTRIBUTE_TABS = `${GTM_ATTRIBUTE_INPLAY};tabs`;
export const GTM_ATTRIBUTE_SEE_ALL = 'see-all';
export const GTM_ATTRIBUTE_WIDGET_SUFFIX = '-widget';

export const FIRST_INDEX = 0;
export const GOAL_SCORER_MAX_SELECTION_EXPANDED = 4;
export const OVER_UNDER_MAX_SELECTION_EXPANDED = 4;
export const MAX_SELECTION_ROWS_NOT_EXPANDED = 5;
export const HOME = '1';
export const DRAW = 'x';
export const VISITANT = '2';
export const THREE_WAY_MARKET_HEADERS = [HOME, DRAW, VISITANT];
